/// <amd-module name="Repos/Tfvc/Views/FilesHub/RestClient/LegacyTfvc" />
import { IFileDiff } from "Repos/FilesHubCommon/Annotate";
import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

type WrappedArray<T> = { __wrappedArray?: T[] };

type Results<T> = { results?: T[] };

export interface AnnotateDiffParameters {
    mFileId: number;
    mEncoding: number;
    mServerItem: string;
    oFileId?: number;
    oEncoding?: number;
    oServerItem?: string;
}

export interface IChangeset {
    changesetId: number;
    comment: string;
    creationDate: Date;
    ownerDisplayName: string;
    version: string;
}

export interface ITfsHistoryEntry {
    changeList: IChangeset;
    encoding: number;
    fileId: number;
    serverItem: string;
}

interface ILegacyTfvcRestClient extends IVssRestClient {
    getFolderLatestChangesets(project: string, path: string, version: string): Promise<IChangeset[]>;
    getFileHistory(project: string, path: string, version: string): Promise<ITfsHistoryEntry[]>;
    getAnnotateDiffs(project: string, diffs: AnnotateDiffParameters[]): Promise<IFileDiff[]>;
}

class LegacyTfvcRestClient extends RestClientBase implements ILegacyTfvcRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    public async getFolderLatestChangesets(project: string, path: string, version: string): Promise<IChangeset[]> {
        return this.beginRequest<WrappedArray<IChangeset>>({
            apiVersion: "5.0",
            method: "GET",
            routeTemplate: "{project}/_api/_versioncontrol/changesets?path={path}&version={version}",
            routeValues: {
                project,
                path,
                version
            }
        }).then(result => (result && result.__wrappedArray) || []);
    }

    public async getFileHistory(project: string, path: string, version: string): Promise<ITfsHistoryEntry[]> {
        return this.beginRequest<Results<ITfsHistoryEntry>>({
            apiVersion: "5.0",
            method: "POST",
            routeTemplate: "{project}/_api/_versioncontrol/history",
            routeValues: {
                project
            },
            body: {
                repositoryId: "",
                searchCriteria: JSON.stringify({
                    itemPath: path,
                    itemVersion: version,
                    top: 1000,
                    skip: 0,
                    followRenames: false, // Git blame is not navigating through renames either
                    excludeDeletes: true,
                    toVersion: version
                })
            }
        }).then(result => (result && result.results) || []);
    }

    public async getAnnotateDiffs(project: string, diffs: AnnotateDiffParameters[]): Promise<IFileDiff[]> {
        return this.beginRequest<WrappedArray<IFileDiff>>({
            apiVersion: "5.0",
            method: "POST",
            routeTemplate: "{project}/_api/_versioncontrol/annotateTfsDiffs",
            routeValues: {
                project
            },
            body: {
                annotateDiffParameters: JSON.stringify(diffs)
            }
        }).then(result => (result && result.__wrappedArray) || []);
    }
}

export const LegacyTfvcClientName = "Repos.FilesHub.Tfvc.ILegacyTfvcRestClient";

export function getLegacyTfvcClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ILegacyTfvcRestClient {
    return pageContext.getRestClient<ILegacyTfvcRestClient>(LegacyTfvcClientName, options);
}

RestClients.add(LegacyTfvcClientName, {
    factory: LegacyTfvcRestClient
});
